import React from "react";
import { Box, ButtonBase, Typography, Collapse } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const QuestionRenderer = ({
  answers,
  questions,
  theme,
  showQuestionDescription,
  setShowQuestionDescription,
  generateAnswerOptions,
  descriptionParams,
}) => {
  return answers
    .filter((answer) => questions.includes(answer.q_title))
    .map((answer, index) => {
      return (
        <Box
          key={index}
          sx={{
            margin: theme.spacing(1.5, 0),
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box
                sx={{
                  flex: "0 1 50%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <ButtonBase
                  sx={{
                    width: "100%",
                    padding: theme.spacing(1),
                    "&:focus": {
                      outline: "none",
                      borderRadius: theme.spacing(0.5),
                      boxShadow: `0 0 0 ${theme.spacing(0.5)} ${
                        theme.palette.info.main
                      }`,
                    },
                    [theme.breakpoints.down("md")]: {
                      margin: theme.spacing(1),
                      padding: 0,
                    },
                  }}
                  onClick={() => {
                    let updatedShowQuestionDescription = {
                      ...showQuestionDescription,
                    };
                    updatedShowQuestionDescription[answer.q_title] =
                      !updatedShowQuestionDescription[answer.q_title];
                    setShowQuestionDescription(updatedShowQuestionDescription);
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: theme.spacing(3),
                      textAlign: "left",
                      [theme.breakpoints.down("md")]: {
                        fontSize: theme.spacing(2),
                      },
                    }}
                  >
                    {answer.q_title}
                  </Typography>
                  {showQuestionDescription[answer.q_title] ? (
                    <KeyboardArrowUpIcon
                      sx={{
                        display: "flex",
                        margin: theme.spacing("auto", 1, "auto", "auto"),
                        fontSize: theme.spacing(2.5),
                      }}
                    />
                  ) : (
                    <InfoOutlinedIcon
                      sx={{
                        display: "flex",
                        margin: theme.spacing("auto", 1, "auto", "auto"),
                        fontSize: theme.spacing(2.5),
                      }}
                      color="info"
                    />
                  )}
                </ButtonBase>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flex: "1 1 50%",
                }}
              >
                {generateAnswerOptions(answer, index, answers)}
              </Box>
            </Box>
            <Collapse in={showQuestionDescription[answer.q_title]}>
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    margin: theme.spacing(1),
                    fontSize: theme.spacing(1.8),
                    [theme.breakpoints.down("md")]: {
                      margin: theme.spacing(1, 0, 1, 1),
                    },
                  }}
                >
                  {typeof answer.q_description === "function"
                    ? answer.q_description(answers, descriptionParams)
                    : answer.q_description}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        </Box>
      );
    });
};

export default QuestionRenderer;
